const randomInt = (min: number, max?: number) => {
  if (max === undefined) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min));
};

export default randomInt;
